(function ($) {

  $(document).ready(function() {
    $('.scroll-nav__link').click(function(e) {
      e.preventDefault(); // prevent hard jump, the default behavior

      var target = $(this).attr("href"); // Set the target as variable

      // perform animated scrolling by getting top-position of target-element and set it as scroll target
      $('html, body').animate({
        scrollTop: $(target).offset().top-125
      }, 600);

      // Add/Remove active class when nav item clicked
      $('.scroll-nav__item').removeClass('scroll-nav__item--active');
      $(this).parent('.scroll-nav__item').addClass('scroll-nav__item--active');

      return false;
    });
  });

  $(window).scroll(function() {
    var scrollDistance = $(window).scrollTop();

    // Assign active class to nav links while scolling
    $('.anchor-nav__section').each(function(i) {
      if ($(this).position().top-150 <= scrollDistance) {
        $('.scroll-nav__list .scroll-nav__item.scroll-nav__item--active').removeClass('scroll-nav__item--active');
        $('.scroll-nav__list .scroll-nav__item').eq(i).addClass('scroll-nav__item--active');
      }
    });
  }).scroll();

})(jQuery);
